module.exports = __webpack_public_path__ + "static/img/visa.542a55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/visa.png
// module id = 338
// module chunks = 1